// gameConstants.js
'use strict';

export const Game = {
  SIC_BO: 'sic-bo',
  DRAGON_TIGER_FIGHT: 'dragon-tiger-fight',
  GIFT_SLOT: 'gift-slot',
  SOARING_HIGH: 'soaring-high',
  GOLDEN_GATE: 'golden-gate',
};

export const GIOCO_GAMES = [
  Game.DRAGON_TIGER_FIGHT,
  Game.GOLDEN_GATE,
  Game.SOARING_HIGH,
];
